module.exports = __webpack_public_path__ + "img/imgvideo.0467ad11.gif";